import styled from 'styled-components'
import {PrimaryStyledButton} from '../../../../../styledComponents/Button'
import {Colors, FontSize, FontWeights} from '../../../../../styledComponents/Constants'
import {currentMedia} from '../../../../../styledComponents/ResponsiveConvenience'
import {StyledPageTitle} from '../../../../../components/reservations/components/CommonStyle'
import {StyledDiv} from '../../../../../styledComponents/StyledTypeDefinitions'

export const ApplyButton = styled(PrimaryStyledButton)`
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 15px;
`

export const ItemHeading = styled.div`
  background-color: ${Colors.AccentLight};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 5px 15px;
  box-sizing: border-box;
  overflow: hidden;
`

export const WideWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 15px;
  box-sizing: border-box;
  overflow: hidden;
`

export const PageTitle = styled(StyledPageTitle)`
  line-height: 1;
`

export const BoldText = styled.span<{ fontColor?: string }>`
  font-weight: ${FontWeights.Bold};
  ${props => props.fontColor ? `
    color:${props.fontColor};
  ` : ''}
`

export const ListGridContainer = styled.div<{ fontSize?: string }>`
  display: grid;
  grid-template-columns: min-content auto;
  ${props => props.fontSize ? `
    font-size:${props.fontSize};
  ` : ''}
`

export const NumberListContainer: StyledDiv = styled.div`
  counter-reset: number 0;
  margin-left: 10px;
`

export const NumberListItem: StyledDiv = styled.div`
   display: flex;
   align-items: baseline;
   margin: 0 0 5px;

   &::before {
    counter-increment: number;
    content: counter(number)".";
    margin: 0 5px 0 0;
    flex-shrink: 0;
  }
`

export const PledgeArea = styled.div<{ fontSize?: string }>`
  background-color: ${Colors.Surface};
  margin: 0 15px;
  ${currentMedia.lessThan('sp')`
    margin: 0;
  `};
  box-sizing: border-box;
  overflow: hidden;
  ${props => props.fontSize ? `
    font-size:${props.fontSize};
  ` : ''}
`

export const PolicyCheckBoxStyled = styled.label`
  font-size: ${FontSize.Body};
`

